import { Component, Input } from '@angular/core';

import { TooltipDirective } from '../tooltip/tooltip.directive';

@Component({
  selector: 'app-key-value',
  standalone: true,
  templateUrl: './shared-ui-key-value.component.html',
  styleUrls: ['./shared-ui-key-value.component.scss'],
  imports: [TooltipDirective],
})
export class KeyValueComponent {
  @Input() public key: string;
  @Input() public value: string;
  @Input() public tooltip?: string;
}
